module.exports = __webpack_public_path__ + "static/media/Mohsin Muslim.c2dc470c.jpg";